import { computed, type ComputedRef } from 'vue'
import { inject } from 'vue'

import type { ExtendedMergedTheme } from './extendedTheme'
import { createExtendedTheme } from './themeLogic'

/**
 * Vue 3 Composition API version - for <script setup> components
 */
export const useExtendedMergedTheme = (): ComputedRef<
  ExtendedMergedTheme | undefined
> => {
  const brandThemePath = inject('brandThemePath') as string
  const storeModule = inject('storeModule') as string
  return computed(() => createExtendedTheme(brandThemePath, storeModule))
}

/**
 * Vue 2 Mixin version - for <script> + export default components
 */
export const useExtendedMergedThemeMixin = {
  computed: {
    mergedTheme() {
      const { brandThemePath, storeModule } = this
      return createExtendedTheme(brandThemePath, storeModule)
    },
  },
  inject: ['brandThemePath', 'storeModule'],
}
